:host {
  display: block;
}

.hr-form-container {
  display: none;
}

.hr-form-container-visible {
  display: block;
}
